import { createEntityCollectionStore, DEFAULT_SCOPE_NAME, pipeState } from '@recruitee/ngrx';

import type { SlackIntegrationHttp } from '../types';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<SlackIntegrationHttp>()('slack-integration', {
    customActions: adapter => ({
      disconnectIntegrationCollection: state => adapter.markAsPending(state),
      disconnectIntegrationsCollectionSuccess: state =>
        pipeState(
          state,
          next => adapter.resetAll(next),
          next => adapter.markAsLoaded(next, { scope: DEFAULT_SCOPE_NAME, entities: [] }),
        ),
      disconnectIntegrationCollectionError: (state, payload) => adapter.setError(state, payload),
    }),
  });

const SlackIntegrationActions = <
  Pick<
    typeof actions,
    | 'removeOnePessimistic'
    | 'removeOnePessimisticSuccess'
    | 'removeOnePessimisticFailed'
    | 'fetchCollection'
    | 'fetchCollectionSuccess'
    | 'fetchCollectionFailed'
    | 'disconnectIntegrationCollection'
    | 'disconnectIntegrationsCollectionSuccess'
    | 'disconnectIntegrationCollectionError'
    | 'updateOnePessimistic'
    | 'updateOnePessimisticSuccess'
    | 'updateOnePessimisticFailed'
  >
>actions;

export {
  SlackIntegrationActions,
  selectors as SlackIntegrationSelectors,
  reducer as SlackIntegrationReducer,
  namespace as SlackIntegrationNamespace,
};
